import { render, staticRenderFns } from "./ItemsEdit.vue?vue&type=template&id=245b95f2&scoped=true"
import script from "./ItemsEdit.vue?vue&type=script&lang=js"
export * from "./ItemsEdit.vue?vue&type=script&lang=js"
import style0 from "./ItemsEdit.vue?vue&type=style&index=0&id=245b95f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b95f2",
  null
  
)

export default component.exports